import { render, staticRenderFns } from "./ProductNoProductsAvailable.vue?vue&type=template&id=c48ac378&scoped=true&"
import script from "./ProductNoProductsAvailable.vue?vue&type=script&lang=js&"
export * from "./ProductNoProductsAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48ac378",
  null
  
)

export default component.exports